import React, { useState, useEffect } from "react";
import './PaymentMethodPage.css';
import EditIcon from '../../assets/images/edit.svg';
import MasterCardLogo from '../../assets/images/mastercard-logo.png';
import VisaLogo from '../../assets/images/visa-logo.png';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Card, Row, Col, notification, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import deletePayment from "../../assets/images/DeletePayment.svg";
import { getPaymentMethods, setDefaultPaymentMethod, deletePaymentMethod } from "../../api/password";
import ConfirmationPopup from "./ConfirmationPopup.js";

const PaymentMethodPage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [methodToDelete, setMethodToDelete] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleGoBackButton = () => {
    navigate("/landing-page");
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const fetchPaymentMethods = async () => {
    try {
      const response = await getPaymentMethods();
      if (response.paymentMethods && response.paymentMethods.length > 0) {
        setPaymentMethods(response.paymentMethods);
        setIsLoading(false);
      } else {
        setPaymentMethods([]);
        notification.info({ message: "No Payment Methods Found", duration: 10 });
      }
    } catch (error) {
      console.error("Error fetching payment methods:", error);
      notification.error({ message: "An error occurred while fetching payment methods", duration: 10 });
    }finally {
      setIsLoading(false);
    }
  };

  const handleAddAnother = () => {
    navigate("/add-payment")
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const handleMakeDefault = async (paymentMethodId) => {
    try {
      await setDefaultPaymentMethod(paymentMethodId);
      notification.success({ message: "Payment Method set as default", duration: 10 });
      fetchPaymentMethods();
    } catch (error) {
      notification.error({ message: "Failed to set default payment method", duration: 10 });
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleDeleteClick = (method) => {
    if (method.isDefault) {
      notification.error({ message: "You can't delete the default payment method. Please set another payment method as default first.", duration: 10 });
      setIsEditing(false);
      return;
    }
    setMethodToDelete(method);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    try {
      await deletePaymentMethod(methodToDelete.paymentMethodId);
      notification.success({ message: "Payment Method deleted successfully", duration: 10 });
      setIsEditing(false);
      setShowDeletePopup(false);
      fetchPaymentMethods();
    } catch (error) {
      notification.error({ message: "Failed to delete payment method", duration: 10 });
    }
  };

  const handlePopupClose = () => {
    setShowDeletePopup(false);
    setIsEditing(false);
  };

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 20 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
          <Col flex="10%" className="go-back-button">
            <button onClick={handleGoBackButton} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
        </Row>

        <div className="payment-methods">
          <h2>Payment Methods</h2>
          <Card className="payment-card">
            <div className="card-header">
              <span>CARDS</span>
              <img src={EditIcon} alt="Edit Icon" className="edit-icon" onClick={handleEditClick} />
            </div>
            <p className="payment-note">We do not store your card data locally, it is held within Stripe. If you delete a card you will have to add it back manually.</p>
            <div className="card-list">
              {!isLoading ? (
                paymentMethods.map((method, index) => (
                  <div className="card-item" key={index}>
                    <img src={method.cardName.toLowerCase() === "visa" ? VisaLogo : MasterCardLogo} alt={method.cardName} />
                    <span className="card-details">
                      {`${method.cardName.charAt(0).toUpperCase() + method.cardName.slice(1)} - ${method.lastDigits} ${method.cardholderName && method.cardholderName !== 'null' ? ` - ${method.cardholderName}` : ''}`}
                    </span>
                    {isEditing ? (
                      <img
                        src={deletePayment}
                        alt="Delete Payment Icon"
                        className="delete-icon"
                        onClick={() => handleDeleteClick(method)}
                      />
                    ) : (
                      method.isDefault ? (
                        <span className="default-label">Default</span>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleMakeDefault(method.paymentMethodId)}
                          className="make-default"
                        >
                          Make Default
                        </button>
                      )
                    )}
                  </div>
                ))
              ) : (
                <Spin>Loading...</Spin>
              )}
              <div className="add-card" onClick={handleAddAnother}>
                + ADD ANOTHER
              </div>
            </div>

          </Card>
        </div>
        {showDeletePopup && (
          <ConfirmationPopup
            title="Delete Payment Method"
            message="This is not reversible!"
            warningText="Are you sure you want to delete this payment method? This action can't be undone."
            onClose={handlePopupClose}
            onConfirm={confirmDelete}
          />
        )}
      </Col>
    </div>
  );
};

export default PaymentMethodPage;
